import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

export default function useInputSearch({ onChange, value, recentSearches, inputRef }) {
  const [debouncedQuerySearch] = useState(() => debounce((query) => querySearch(query), 500));
  const [showRecentSearches, setShowRecentSearches] = useState(false);
  const [inputVal, setInputVal] = useState(value);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        // Aquí puedes manejar el clic fuera del componente
        onHideRecentSearches();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  function querySearch(query) {
    onChange(query);
  }

  function handleChange(event) {
    setInputVal(event.target.value);
    debouncedQuerySearch(event.target.value);
  }

  function onShowRecentSearches() {
    if (recentSearches.length > 0) {
      setShowRecentSearches(true);
    }
  }

  function onHideRecentSearches() {
    setShowRecentSearches(false);
  }

  function onRepeatSearch(item) {
    setInputVal(item);
    onHideRecentSearches();
    onChange(item);
  }

  useEffect(() => {
    if (value === '') {
      setInputVal('');
    }
  }, [value]);

  return { inputVal, showRecentSearches, handleChange, onHideRecentSearches, onShowRecentSearches, onRepeatSearch };
}
